// Crimson night theme for the Ferris wheel.
// Anchored on the brand primary red (#E91E63); supporting shades are
// warm gold, ivory, and rose so the canvas reads as a cohesive whole.
export const ROYAL_FERRIS_THEME = Object.freeze({
  transparent: 'rgba(0,0,0,0)',
  shadow: 0x000000,
  ivory: 0xfff5ee,
  pearl: 0xffffff,
  champagne: 0xffe1c2,
  champagneSoft: 0xfff0dc,
  gold: 0xf6c04d,
  goldBright: 0xffdf7a,
  goldDeep: 0xa86505,
  antiqueGold: 0xc88d28,
  royalBronze: 0x7b4a07,
  plumBlack: 0x1a0410,
  plumDeep: 0x2c0a18,
  plum: 0x5e1530,
  amethyst: 0xe91e63,
  amethystBright: 0xff5c8d,
  sapphireDeep: 0x2a0010,
  sapphire: 0x7a1330,
  sapphireGlow: 0xff7da3,
  ruby: 0xe91e63,
  rubyBright: 0xff5c8d,
  emerald: 0x28c987,
  podShell: 0xfff5ee,
  podSeat: 0xffe1c2,
  podSeatGlow: 0xffffff,
  selectedRing: 0xffdf7a,
  selectedRingInner: 0xffffff,
  badgeFill: 0xc2185b,
  badgeStroke: 0xffdf7a,
  winnerRing: 0xffdf7a,
  textIvory: '#fff5ee',
  textPlum: '#2a0010',
  textSapphire: '#2a0010',
  textBronze: '#704005',
  textRuby: '#7a1330',
  textMutedGold: '#d8b66d',
  glowRamp: Object.freeze({
    fast: 0xe91e63,
    mid: 0xff7da3,
    slow: 0xffdf7a,
    final: 0xfff0b6,
  }),
  sparkles: Object.freeze([0xffdf7a, 0xfff0b6, 0xffffff, 0xff5c8d, 0xe91e63]),
});
